import { List, useRecordContext } from "react-admin";

import { OrganizationRecordWithLocations } from "../types/organization";
import { LocationDataGrid } from "./LocationDataGrid";

export const OrganizationLocationsList = () => {
  const record = useRecordContext<OrganizationRecordWithLocations>();

  if (!record) return null;

  return (
    <List
      resource="Location"
      filter={{ organizationId: record.id, physicalRootsOnly: true }}
      perPage={50}
      actions={false}
    >
      <LocationDataGrid />
    </List>
  );
};
